import { faExchange, faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Button, Empty, Table } from 'antd';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import ListHeader from '../../../../components/ListHeader';
import { Company } from '../../../../models/company-interface';
import { CompanyProductVersionModel, Feature, ProductVersionModel } from '../../../../models/product-interface';
import { Profile } from '../../../../models/profile-interface';
import SyncProductModal from '../../../../components/modals/SyncProductModal';
import { HasRight, Rights } from '../../../../utilites/auth';

type Filter = {
  text: string;
  value: number | string;
}

type Props = {
    profile: Profile;
    product: ProductVersionModel;
    allProductVersions: ProductVersionModel[];
    visible: boolean;
    hasMultipleVersions: boolean;
}
  
const ProductCompanies: React.FC<Props> = ({ 
  profile,
  product,
  allProductVersions,
  visible,
  hasMultipleVersions
}) => {

    const history = useHistory();
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
    const [filteredData, setFilteredData] = useState<Company[]>(null);
    const [syncVisible, setSyncVisible] = useState<boolean>(false);
    const [isSearching, setIsSearching] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const companies = product?.companies ?? []
        setFilteredData(product.companies)
        setSelectedRowKeys([]);
    }, [product]);

  const companyProductVersion: CompanyProductVersionModel = {
    versionId: product.versionId,
    newerVersions: allProductVersions,
    features: product.features,
    product: product.product,
    date: product.date,
  }
    
  const columns: any = [
    {
      title: 'Company ID',
      dataIndex: 'id',
      width: '150px',
      key: 'id',
      render: (id: number, record: Company) => {
        return (id
        )
      },
      sorter: {
        compare: (a: Company, b: Company) =>
          a.id == b.id ? 0 : a.id > b.id ? -1 : 1
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: Company) => {
        return (<Button
        type="link"
        href={`/admin/company/${record.id}`}
        onClick={(e) => {
          e.preventDefault();
          history.push(`/admin/company/${record.id}`)
        }}
      >
        {name}
      </Button>)
      },
      sorter: {
        compare: (a: Company, b: Company) =>
          a.name.localeCompare(b.name)
      },
    },
  ];

  
    /**
     * Search table function
     * @param value 
     */
     const onSearch = (value: string) => {
        const searchedData = product.companies.filter(o => o.name.toLowerCase().includes(value.toLowerCase()))
        searchedData.forEach(x => x.key = x.id)
        setFilteredData(value.length > 0 ? searchedData : product.companies);
        setIsSearching(value.length > 0 ? true : null);
    }

    
    /**
    * On selection changes
    * @param selectedRowKeys
    */
     const onSelectChange = (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
        // setValue(value + 1);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    };

    /**
     * Unselect all rows
     */
    const handleUnselectAll = () => {
        setSelectedRowKeys([]);
    }



    /**
     * Actions for header
     */
     const actions = [
        {
            singleName: "Move Version",
            multiName: "Move Version",
            multiSelect: true,
            alwaysEnabled: selectedRowKeys.length > 0,
            icon: faExchange,
            tag: "MoveVersion",
            forceDisable: !hasMultipleVersions,
            onClick: () => {
              setSyncVisible(true);
            }
        }
    ];

  return <React.Fragment key={"companies"}>
    <ListHeader 
        actions={actions}
        tag="productCompanies"
        selectedItems={selectedRowKeys?.length ?? 0}
        totalItems={product.companies.length}
        searchPlaceholder="Search companies"
        unselectAll={handleUnselectAll}
        onSearch={onSearch}
        reset={visible}
    />
    <Table
      columns={columns}
      rowSelection={rowSelection}
      dataSource={filteredData}
      size="middle"
      rowKey={(val) => val.id}
      locale={{
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={`No companies`} />
      }}
      scroll={{ x: 715 }}
      pagination={{defaultPageSize: 20}}
    />
    <SyncProductModal
      isVisible={syncVisible}
      handleClose={() => {
        setSyncVisible(false);
        setSelectedRowKeys([]);
      }}
      product={companyProductVersion}
      companyIds={selectedRowKeys}
      companyNames={filteredData?.filter(x => selectedRowKeys.includes(x.id)).map(x => x.name)}
      canUpdate={HasRight([Rights.CSAdmin])}
    />
  </React.Fragment>
}


export default ProductCompanies;